import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation('common');
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#F5F7F3] text-gray-700">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-10 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12">
          {/* Brand */}
          <div>
            <h3
              className="text-xl sm:text-2xl font-light text-[#4A5D44] mb-3 sm:mb-4"
              style={{ fontFamily: 'Cormorant Garamond, serif' }}
            >
              {t('footer.brand')}
            </h3>
            <p className="text-xs sm:text-sm font-light leading-relaxed text-gray-600">
              {t('footer.tagline')}
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-sm sm:text-base font-normal text-[#4A5D44] mb-3 sm:mb-4 uppercase tracking-wider">
              {t('footer.navigation')}
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-xs sm:text-sm font-light hover:text-[#8B9D83] transition-colors cursor-pointer"
                >
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-xs sm:text-sm font-light hover:text-[#8B9D83] transition-colors cursor-pointer"
                >
                  {t('nav.about')}
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="text-xs sm:text-sm font-light hover:text-[#8B9D83] transition-colors cursor-pointer"
                >
                  {t('nav.services')}
                </Link>
              </li>
              <li>
                <Link
                  to="/testimonials"
                  className="text-xs sm:text-sm font-light hover:text-[#8B9D83] transition-colors cursor-pointer"
                >
                  {t('nav.testimonials')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-sm sm:text-base font-normal text-[#4A5D44] mb-3 sm:mb-4 uppercase tracking-wider">
              {t('footer.services')}
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/payment"
                  className="text-xs sm:text-sm font-light hover:text-[#8B9D83] transition-colors cursor-pointer"
                >
                  {t('footer.vipSupport')}
                </Link>
              </li>
              <li>
                <Link
                  to="/payment"
                  className="text-xs sm:text-sm font-light hover:text-[#8B9D83] transition-colors cursor-pointer"
                >
                  {t('footer.fmdProtocol')}
                </Link>
              </li>
              <li>
                <Link
                  to="/payment"
                  className="text-xs sm:text-sm font-light hover:text-[#8B9D83] transition-colors cursor-pointer"
                >
                  {t('footer.childNutrition')}
                </Link>
              </li>
              <li>
                <Link
                  to="/payment"
                  className="text-xs sm:text-sm font-light hover:text-[#8B9D83] transition-colors cursor-pointer"
                >
                  {t('footer.groupIntensive')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm sm:text-base font-normal text-[#4A5D44] mb-3 sm:mb-4 uppercase tracking-wider">
              {t('footer.contact')}
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-[#8B9D83] mt-0.5 w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
                <a
                  href="mailto:minequi@hotmail.com"
                  className="text-xs sm:text-sm font-light hover:text-[#8B9D83] transition-colors cursor-pointer"
                >
                  minequi@hotmail.com
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-[#8B9D83] mt-0.5 w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
                <a
                  href="tel:+1234567890"
                  className="text-xs sm:text-sm font-light hover:text-[#8B9D83] transition-colors cursor-pointer"
                >
                  +47 468 84 700
                </a>
              </li>
            </ul>
            <div className="flex gap-4 mt-4 sm:mt-6">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-[#8B9D83] text-white hover:bg-[#7A8C72] transition-colors cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-base" aria-hidden="true"></i>
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-[#8B9D83] text-white hover:bg-[#7A8C72] transition-colors cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-base" aria-hidden="true"></i>
              </a>
              <a
                href="https://telegram.org"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-[#8B9D83] text-white hover:bg-[#7A8C72] transition-colors cursor-pointer"
                aria-label="Telegram"
              >
                <i className="ri-telegram-fill text-base" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-300 mt-8 sm:mt-12 pt-6 sm:pt-8 text-center">
          <p className="text-xs sm:text-sm font-light text-gray-600">
            {t('footer.copyright', { year: currentYear })}
          </p>
        </div>
      </div>
    </footer>
  );
}